import mitt from "mitt";

export default mitt();

export enum EmitterEvents {
  "ORG_MEMBER_CREATED" = "ORG_MEMBER_CREATED",
  "APP_LAYOUT_SHOW_TOAST_MESSAGE" = "APP_LAYOUT_SHOW_TOAST_MESSAGE",
  "APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY" = "APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY",
  "ROLE_CREATED" = "ROLE_CREATED",
  "EVENT_KEYBOARD_ENTER" = "EVENT_KEYBOARD_ENTER",
  "EVENT_KEYBOARD_ESC" = "EVENT_KEYBOARD_ESC",
  "OPEN_REQUEST_MODAL" = "OPEN_REQUEST_MODAL",
  "OPEN_MODAL" = "OPEN_MODAL",
  "CLOSE_MODAL" = "CLOSE_MODAL",
  "OPEN_IMAGE_MODAL" = "OPEN_IMAGE_MODAL",
  "EVENT_SWITCH_ORG" = "EVENT_SWITCH_ORG",
  "OPEN_RIGHT_SLIDE_MODAL" = "OPEN_RIGHT_SLIDE_MODAL",
  "CLOSE_ALL_POPOVERS" = "CLOSE_ALL_POPOVERS",
  "CLICK_UPLOAD_FILE" = "CLICK_UPLOAD_FILE",
  "OPEN_WIZARD_DELETE_MODAL" = "OPEN_WIZARD_DELETE_MODAL",
  "CLICK_SORT_COLUMN_ACTION_TABLE" = "CLICK_SORT_COLUMN_ACTION_TABLE",
  "RESET_SORT_TABLE" = "RESET_SORT_TABLE",
  "REFRESH_ORG_DATA" = "REFRESH_ORG_DATA",
  "SERVICE_UPDATE_ITEM" = "SERVICE_UPDATE_ITEM",
  "SERVICE_DELETE_ITEM" = "SERVICE_DELETE_ITEM",
  "PAGE_LOADING_COMPLETED" = "PAGE_LOADING_COMPLETED",
  "RELOAD_MANAGE_MEMBERSHIPS" = "RELOAD_MANAGE_MEMBERSHIPS",
  "RELOAD_CURRENT_USER_MEMBERSHIPS" = "RELOAD_CURRENT_USER_MEMBERSHIPS",
  "ADD_NEW_ASSESSMENT_QUESTION_TO_ACTION" = "ADD_NEW_ASSESSMENT_QUESTION_TO_ACTION",
  "RELOAD_RECOMMENDATION" = "RELOAD_RECOMMENDATION",
  "RELOAD_RECOMMENDATION_ACTIONS" = "RELOAD_RECOMMENDATION_ACTIONS",
  "HIDDEN_SETTINGS" = "HIDDEN_SETTINGS",
  "SCROLL_TO_TOP" = "SCROLL_TO_TOP",
  "SHOW_PRICING_TABLE" = "SHOW_PRICING_TABLE",
  "UPDATE_PASSWORD_ASSESSMENT_QUESTION" = "UPDATE_PASSWORD_ASSESSMENT_QUESTION",
  "SHARING_ADD_INCIDENT" = "SHARING_ADD_INCIDENT",
  "SHARING_CONFIRM_UPSERT_INCIDENT" = "SHARING_CONFIRM_UPSERT_INCIDENT",
  "UPDATE_CHEVRON_ACTIVE" = "UPDATE_CHEVRON_ACTIVE",
  "REMOVE_ITEM_SELECTED_ROW" = "REMOVE_ITEM_SELECTED_ROW",
  "OPEN_SCAN_POPOVER" = "OPEN_SCAN_POPOVER",
  "SET_PRIMARY_MENU_INDEX" = "SET_PRIMARY_MENU_INDEX",
  "CLOSE_RIGHT_SLIDE_MODAL" = "CLOSE_RIGHT_SLIDE_MODAL",
  "VALUE_SEARCH" = "VALUE_SEARCH",
  "CLOSE_GLOBAL_SEARCH" = "CLOSE_GLOBAL_SEARCH",
  "APP_LAYOUT_SHOW_COLLAPSABLE_MENU" = "APP_LAYOUT_SHOW_COLLAPSABLE_MENU",
  "EXTERNAL_MEMBERS_LOADING_COMPLETED" = "EXTERNAL_MEMBERS_LOADING_COMPLETED",
  "INTERNAL_MEMBERS_LOADING_COMPLETED" = "INTERNAL_MEMBERS_LOADING_COMPLETED",
  "CREATE_VENDOR_TEMPLATE" = "CREATE_VENDOR_TEMPLATE",
  "SCROLL_MODAL" = "SCROLL_MODAL",
  "SAVE_AND_CLOSE_REVIEW_VENDOR" = "SAVE_AND_CLOSE_REVIEW_VENDOR",
  "VENDOR_ITEM_VALID_SUCCESS" = "VENDOR_ITEM_VALID_SUCCESS",
  "VENDOR_ITEM_INVALID" = "VENDOR_ITEM_INVALID",
  "CLOSE_ASSESSMENT_ADVANCED_MENU" = "CLOSE_ASSESSMENT_ADVANCED_MENU",
}
